import React from 'react';

const ASSET_TYPE_LABELS = {
  FUND: 'Quỹ mở',
  STOCK: 'Cổ phiếu',
  ETF: 'ETF',
  CRYPTO_SPOT: 'Crypto',
  CRYPTO_FUTURES: 'Futures',
};

function formatNumber(value, decimals = 2) {
  if (value == null) return '—';
  return new Intl.NumberFormat('vi-VN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(value);
}

function formatPercent(value) {
  if (value == null) return '—';
  const prefix = value > 0 ? '+' : '';
  return `${prefix}${value.toFixed(2)}%`;
}

export default function PositionRow({ position }) {
  const isGain = position.gainAmount != null && position.gainAmount > 0;
  const isLoss = position.gainAmount != null && position.gainAmount < 0;
  const gainColor = isGain ? 'text-green-600' : isLoss ? 'text-red-600' : 'text-gray-500';

  return (
    <tr className="border-b border-gray-50 transition-colors hover:bg-gray-50">
      <td className="px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-900">{position.symbol}</span>
          <span className="inline-flex rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-500">
            {ASSET_TYPE_LABELS[position.assetType] || position.assetType}
          </span>
        </div>
      </td>
      <td className="px-4 py-3 text-right text-sm text-gray-600">
        {formatNumber(position.quantity, 4)}
      </td>
      <td className="px-4 py-3 text-right text-sm text-gray-600">
        {formatNumber(position.costPrice)}
      </td>
      <td className="px-4 py-3 text-right text-sm text-gray-600">
        {formatNumber(position.costBasis)}
      </td>
      <td className="px-4 py-3 text-right text-sm text-gray-600">
        {position.currentPrice != null ? formatNumber(position.currentPrice) : '—'}
      </td>
      <td className="px-4 py-3 text-right text-sm text-gray-600">
        {position.currentAmount != null ? formatNumber(position.currentAmount) : '—'}
      </td>
      <td className={`px-4 py-3 text-right text-sm font-medium ${gainColor}`}>
        {position.gainAmount != null ? (
          <div>
            <div>{formatNumber(position.gainAmount)}</div>
            <div className="text-xs">{formatPercent(position.gainPercent)}</div>
          </div>
        ) : '—'}
      </td>
    </tr>
  );
}
